import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../Components/Button/Button.jsx";
import "./Dashboard.css";
import Modal from "../../Components/Modal/Modal.jsx";
import { getUserByRole, saveCandidateName, saveResumeTitle, uploadResume } from "../../Api/apiService.js";
import { useSelector } from "react-redux";
import Input from "../../Components/Input/Input.jsx";
import { ToastContainer, toast } from "react-toastify";
const EmployeeSelection = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [allEmployees, setAllEmployees] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [resumeTitle, setResumeTitle] = useState("");
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth);

  useEffect(() => {
    fetchUserByRole();
  }, []);

  const fetchUserByRole = async () => {
    try {
      const response = await getUserByRole();
      setAllEmployees(response.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch employees", {
        autoClose: 2000,
      });
    }
  };

  const handleEmployeeSelect = (event) => {
    setSelectedEmployeeId(event.target.value);
  };

  const handleTitleSave = async () => {
    if (!resumeTitle || !selectedEmployeeId) {
      toast.error("Please select an employee and enter a resume title.", {
        autoClose: 2000,
      });
      return;
    }

    try {
      const response = await saveResumeTitle(resumeTitle, selectedEmployeeId);
      if (response?.status === 200 || response?.status === 201) {
        const profileId = response.data.id;
        localStorage.setItem("profileId", profileId);
        localStorage.setItem("selectedRole", "employee");

        toast.success(response?.data?.message || "Resume Title Saved", {
          autoClose: 2000,
        });

        setTimeout(() => {
          document.getElementById("resume").click();
        }, 1000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save title", {
        autoClose: 2000,
      });
    }
  };


  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal show={isModalOpen} onClose={closeModal}>
        <label className="form-field-label" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
          Employee List
        </label>
        <div style={{ marginTop: "2%" }}>
          <label htmlFor="employeeSelect" className="form-field-label">
            Select Employee
          </label>
          <br />
          <select
            id="employeeSelect"
            value={selectedEmployeeId}
            onChange={handleEmployeeSelect}
            style={{ width: "91%" }}
            className="form-field-input profile-input-field-password"
          >
            <option value="">Select an employee</option>
            {allEmployees.map((employee) => (
              <option key={employee.userId} value={employee.userId}>
                {employee.name}
              </option>
            ))}
          </select>

          <Input
            className="profile-input-field-password"
            type="text"
            label="Enter Resume Title"
            value={resumeTitle}
            onChange={(e) => setResumeTitle(e.target.value)}
          />
        </div>

        <Button className="change-btn" onClick={handleTitleSave}>
          Choose a file
        </Button>

        {/* <input
          id="resume"
          type="file"
          accept="application/pdf"
          style={{ display: "none" }}
          onChange={handleUploadResume}
        /> */}
      </Modal>
      <ToastContainer />
    </>
  );
};

export default EmployeeSelection;